/**
 * A task's due date is conceptually a calendar DAY but is stored as a UTC
 * timestamp whose time-of-day is noise, so rendering it in the viewer's local
 * timezone can drift onto the wrong calendar day. `getTaskDueDay` collapses a
 * resolved due date to a stable day, taken from its UTC date components and
 * re-expressed as a local-midnight `Date`, so every viewer renders and buckets
 * the same intended day regardless of timezone.
 *
 * Use it for DAY-level display + calendar bucketing only. Do NOT use it for
 * overdue / due-soon math (`tasksStatuses`) — those compare the full instant
 * against `Date.now()` and must keep the real timestamp.
 */
export const getTaskDueDay = (date: Date | null | undefined): Date | null => {
  if (!date) return null;
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};
